import script from "./insurance-factor-view-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-factor-view-popup.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-factor-view-popup.vue?vue&type=style&index=0&id=2078833a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2078833a"]])

export default __exports__